import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../redux/hooks";
import { logoutThunk } from "../../common/redux/thunks/auth/logout-thunk";
import { urls } from "../../urls";

// Navigating to the login page clears the ended session's URL, so LoginRedirect cannot
// capture it as a return_to target for whoever logs in next.
export const useLogout = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  return async () => {
    await dispatch(logoutThunk());
    navigate(urls.login, { replace: true });
  };
};
